
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.$nextTick(() => {
      const mm = this.$gsap.matchMedia(this.$refs.container)
      const timeline = this.$gsap.timeline({ paused: true })

      mm.add('(min-width: 640px)', () => {
        // gather numbers to animate
        this.$gsap.utils.toArray('.points-text').forEach((el, i) => {
          const target = { val: 0 }
          timeline.to(
            target,
            {
              val: el.getAttribute('data-number'),
              duration: 1,
              delay: i * 0.1,
              onUpdate() {
                el.innerHTML = target.val.toFixed(2)
              },
            },
            0
          )
        })

        const tl = this.$gsap.timeline({
          scrollTrigger: {
            trigger: this.$refs.container,
            start: 'top bottom-=25%',
            // end: 'max',
            // markers: true,
          },
          onStart: () => {
            // increment numbers
            timeline.play()
          },
        })

        // width animation
        tl.from('.bar', {
          width: '0%',
          duration: 1,
          stagger: 0.1,
          ease: 'back(.5)',
        })
      })
    })
  },
  methods: {
    progressBarStyles(rowItem) {
      const points = rowItem?.points
      if (!points) return '0'

      // convert poin text to width percentage
      const width = parseFloat(points) * 10 + '%'

      return {
        backgroundColor: rowItem.color || 'black',
        width,
      }
    },
  },
}
